import { motion } from "framer-motion";
import { Gift } from "lucide-react";
import { ordinal } from "../../engine/tools";
import type { RafflePlace } from "../../types";

const PLACE_STYLE = [
  { box: "bg-gradient-to-b from-[#FFE14D] to-[#FFB000] border-[#B87300]", icon: "h-10 w-10 text-[#8a5300]", num: "text-5xl" },
  { box: "bg-gradient-to-b from-[#F2F4F7] to-[#C9CED6] border-[#7C8594]", icon: "h-8 w-8 text-[#4b5563]", num: "text-4xl" },
  { box: "bg-gradient-to-b from-[#F6C7A0] to-[#D98A4E] border-[#8A4B1F]", icon: "h-7 w-7 text-[#6b3410]", num: "text-3xl" },
  { box: "bg-[#FFD1EC] border-[#C2468F]", icon: "h-6 w-6 text-[#8f2a66]", num: "text-2xl" },
  { box: "bg-[#CDEBFF] border-[#3B82C4]", icon: "h-5 w-5 text-[#1f5d94]", num: "text-2xl" },
];

export function RafflePodium({ podium, fast }: { podium: RafflePlace[]; fast: boolean }) {
  const n = podium.length;
  return (
    <div className="space-y-2" data-testid="raffle-podium">
      <p className="text-center"><span className="ua-highlight text-lg sm:text-xl" data-testid="result-reveal-heading">And the winners are…</span></p>
      {podium.map((p) => {
        const s = PLACE_STYLE[p.place - 1];
        return (
          <motion.div key={p.place} data-testid={`raffle-winner-${p.place}`}
            initial={fast ? false : { opacity: 0, x: -30, scale: 0.9 }} animate={{ opacity: 1, x: 0, scale: 1 }}
            transition={{ delay: fast ? 0 : (n - p.place) * 0.55, type: "spring", stiffness: 420, damping: 20 }}
            className={`flex items-center gap-3 rounded-2xl border-[3px] px-3 py-2 ${s.box}`}>
            <Gift className={`shrink-0 ${s.icon}`} strokeWidth={2.5} />
            <span className="min-w-0 flex-1">
              <span className="block font-comic text-xs uppercase text-[#3b1800]/70">{ordinal(p.place)} prize</span>
              <span className="block truncate font-comic text-base text-[#3b1800]" data-testid={`raffle-prize-${p.place}`}>{p.prize}</span>
            </span>
            <span className={`ua-logo shrink-0 ${s.num}`} data-testid={`raffle-ticket-${p.place}`}>#{p.ticket}</span>
          </motion.div>
        );
      })}
    </div>
  );
}
